export default class Map {
  constructor (options) {
    // intialise Google Map
    function initialize() {
      var myLatlng = new google.maps.LatLng(-37.834230, 144.981830),
      mapOptions = {
        zoom: 17,
        center: myLatlng,
        scrollwheel: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: false,
        styles: [
          {
            "featureType": "all",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "all",
            "elementType": "labels.text",
            "stylers": [
              {
                "color": "#23231d"
              },
              {
                "saturation": "-0"
              },
              {
                "lightness": "-77"
              },
              {
                "gamma": "5.20"
              }
            ]
          },
          {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "landscape.man_made",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#c4bfb6"
              },
              {
                "saturation": "0"
              },
              {
                "lightness": "60"
              },
              {
                "gamma": "1.00"
              }
            ]
          },
          {
            "featureType": "landscape.man_made",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "landscape.natural",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#f4f2f1"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.attraction",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.attraction",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#b53c3c"
              }
            ]
          },
          {
            "featureType": "poi.business",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "poi.business",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#bac0b5"
              }
            ]
          },
          {
            "featureType": "poi.business",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#872020"
              }
            ]
          },
          {
            "featureType": "poi.business",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#bac0b5"
              },
              {
                "lightness": "30"
              },
              {
                "saturation": "30"
              },
              {
                "gamma": "1.00"
              }
            ]
          },
          {
            "featureType": "poi.sports_complex",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "poi.sports_complex",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#bac0b5"
              },
              {
                "saturation": "30"
              },
              {
                "lightness": "30"
              },
              {
                "gamma": "1.00"
              }
            ]
          },
          {
            "featureType": "poi.sports_complex",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#c4bfb6"
              },
              {
                "lightness": "39"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#c4bfb6"
              },
              {
                "lightness": "40"
              },
              {
                "gamma": "1.00"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "saturation": "-37"
              },
              {
                "lightness": "26"
              }
            ]
          }
        ]
      }

      var map = new google.maps.Map(document.getElementById('map'), mapOptions)

      var sizeX = 48;
      var sizeY = 67;

      var icon = {
        url: templateDir + '/components/map/botanical-map-pin.svg',
        size: new google.maps.Size(sizeX, sizeY),
        origin: new google.maps.Point(0, 0),
      };

      var marker = new google.maps.Marker({
        position: myLatlng,
        map: map,
        icon: icon
      })

      google.maps.event.addDomListener(window, "resize", function() {
        var center = map.getCenter()
        google.maps.event.trigger(map, "resize")
        map.setCenter(center)
      })
    }

    google.maps.event.addDomListener(window, 'load', initialize)
  }
}



// WEBPACK FOOTER //
// ./components/map/index.js